import { type PropsWithChildren, useEffect, useState } from 'react';

import { isNotDefined } from '@sgme/fp';

import { createContext } from 'react';
import { setupSgwtConnectWidget, type SgConnectUserInfo } from './sgwtConnect';
import { ServiceLoader } from './App/Shared/ServiceLoader';

const emptyUserInfo = {
  mail: '',
  name: '',
  sesame_id: '',
  origin_network: '',
} as const satisfies SgConnectUserInfo;

export const userInfoContext = createContext<SgConnectUserInfo>(emptyUserInfo);

export function UserInfoContextProvider({ children }: Readonly<PropsWithChildren>) {
  const [userInfo, setUserInfo] = useState<SgConnectUserInfo>();

  useEffect(() => {
    setupSgwtConnectWidget({ onUserInfo: setUserInfo });
  }, []);

  if (isNotDefined(userInfo)) {
    return <ServiceLoader />;
  }

  return <userInfoContext.Provider value={userInfo}>{children}</userInfoContext.Provider>;
}
